import React, { useState } from 'react';
import { Alert } from 'antd';
import { PDFSkeleton } from '../../Common/Skeletons';
import PdfJsPages from './PdfJsPages';
import { isTouchDevice } from './isTouchDevice';
import './PDFViewer.css';

// Desktop: the browser's own PDF viewer in an iframe.
const IframePDFViewer = ({ url, filename, fileSize, isDarkMode }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleLoad = () => {
    setLoading(false);
    setError(null);
  };

  const handleError = () => {
    setLoading(false);
    setError('Failed to load PDF. The file may be corrupted or access may be restricted.');
  };

  if (error) {
    return (
      <div className={`pdf-viewer-error ${isDarkMode ? 'dark' : 'light'}`}>
        <Alert
          type="error"
          message="PDF Loading Failed"
          description={
            <div>
              <p>{error}</p>
              <p>Please try downloading the file to view it locally.</p>
            </div>
          }
          showIcon
        />
      </div>
    );
  }

  return (
    <div className={`pdf-viewer ${isDarkMode ? 'dark' : 'light'}`}>
      {loading && (
        <div className="pdf-viewer-loading">
          <PDFSkeleton />
        </div>
      )}
      <iframe
        src={url}
        title={filename}
        className="pdf-iframe"
        onLoad={handleLoad}
        onError={handleError}
        style={{ opacity: loading ? 0 : 1 }}
      />
    </div>
  );
};

// Phones and tablets (touch, no mouse) cannot show a PDF in an iframe (iOS paints one clipped
// page, Android nothing), so they get the pages rendered by pdf.js. Decided once per mount.
const PDFViewer = (props) => {
  const [touch] = useState(isTouchDevice);
  return touch ? <PdfJsPages {...props} /> : <IframePDFViewer {...props} />;
};

export default PDFViewer;
